import { get } from '@/api/request'
import { PaginationResponse, PaginationParams } from '@/api/base'

// 品牌信息
export interface Promotion {
  id: number
  title: string
  description: string
  image: string
  date: string
  link?: string
}

/**
 * 获取动态列表
 */
export const queryPromotionList = (params: PaginationParams = { page: 1, size: 10 }) => {
  return get<PaginationResponse<Promotion>>(' /authenti-guard/v1/api/news/list', params)
}

/**
 * 获取动态详情
 */
export const queryPromotionDetail = (promotionId: number) => {
  return get<Promotion>(`/authenti-guard/v1/api/news/${promotionId}`)
}

/**
 * 获取品牌产品列表
 */
// export const queryBrandProducts = (brandId: number, params: PaginationParams = { page: 1, size: 10 }) => {
//   return get<PaginationResponse<BrandProduct>>(`/authenti-guard/v1/api/brands/${brandId}/products`, params)
// }
